var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectionsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "white",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.334 2C25.9904 2 27.4912 2.67183 28.5763 3.75775C29.6622 4.84367 30.334 6.34368 30.334 8.00003C30.334 8.96425 30.1067 9.87524 29.7028 10.6823C28.9304 12.2262 25.0236 14.9127 24.334 17.8316C23.216 14.9981 19.7385 12.2262 18.9653 10.6823C18.5613 9.87524 18.334 8.96425 18.334 8.00003C18.334 4.68649 21.0205 2 24.334 2Z",
    stroke: "currentColor",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3323 4.96094C25.9743 4.96094 27.3053 6.29193 27.3053 7.93391C27.3053 9.57589 25.9743 10.9069 24.3323 10.9069C22.6904 10.9069 21.3594 9.57589 21.3594 7.93391C21.3594 6.29193 22.6904 4.96094 24.3323 4.96094Z",
    stroke: "currentColor",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99825 8.32227C12.2529 8.32227 14.2938 9.23579 15.771 10.7138C17.2481 12.191 18.1625 14.2319 18.1625 16.4865C18.1625 17.7981 17.8524 19.0386 17.3031 20.1364C16.2518 22.2364 10.9363 25.893 9.99825 29.8649C8.47712 26.0097 3.74471 22.2373 2.69344 20.1364C2.14414 19.0386 1.83398 17.7989 1.83398 16.4865C1.83398 11.9781 5.48894 8.32227 9.99825 8.32227Z",
    stroke: "currentColor",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 12.3506C12.2348 12.3506 14.0458 14.1616 14.0458 16.396C14.0458 18.6303 12.2348 20.4413 10.0005 20.4413C7.76608 20.4413 5.95508 18.6303 5.95508 16.396C5.95508 14.1616 7.76608 12.3506 10.0005 12.3506Z",
    stroke: "currentColor",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3008 30.3352C15.0946 30.7721 20.3831 30.4315 23.7896 30.1129C29.9332 29.5391 29.2225 25.5419 23.8639 25.187C22.8676 25.1211 20.3273 25.0222 19.7239 24.7239C18.5019 24.1197 18.2248 22.3442 19.9715 21.8219C20.6653 21.6149 21.8104 21.4425 22.6496 20.8256C23.2977 20.3489 23.9104 19.6011 24.36 18.3613",
    stroke: "currentColor",
    strokeWidth: 1.12107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsWhite);
export default __webpack_public_path__ + "static/media/directions-white.315420dfbd1bba8b2c0a43cb1b66ae7d.svg";
export { ForwardRef as ReactComponent };